export default "__VITE_ASSET__BmhauEL1__"